import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import API from "../utils/API";
import "./feedbackDetailModal.css";

export default function FeedbackDetailModal({ requestId, contactId, onClose }) {
    const [request, setRequest] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        setLoading(true);
        setError(false);
        API.getFeedbackRequestDetail(requestId)
            .then(res => setRequest(res.data))
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    }, [requestId]);

    const recipient = (request?.ClientFeedbackRecipients || []).find(r => String(r.contact_id) === String(contactId));
    const contact = recipient?.TeamClientContact;
    const responses = (request?.ClientFeedbackResponses || []).filter(r => String(r.contact_id) === String(contactId));

    return (
        <div className="modal fade show d-block fdm-overlay" tabIndex="-1" onClick={onClose}>
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable fdm-dialog" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-header fdm-header">
                        <div>
                            <h5 className="modal-title fdm-title">Feedback Details</h5>
                            {request?.TeamClient && <div className="fdm-subtitle">{request.TeamClient.client_name}</div>}
                        </div>
                    </div>
                    <div className="modal-body fdm-body">
                        {loading ? (
                            <div className="fdm-loading">Loading…</div>
                        ) : error || !request ? (
                            <div className="fdm-error">Unable to load feedback details.</div>
                        ) : (
                            <>
                                <div className="fdm-request-title">{request.title}</div>
                                {contact && (
                                    <div className="fdm-respondent-name">
                                        <i className="bi bi-person me-1" />
                                        {contact.first_name} {contact.last_name}
                                    </div>
                                )}
                                {responses.length === 0 ? (
                                    <p className="text-muted fdm-empty">No feedback notes found.</p>
                                ) : (
                                    <div className="fdm-bill-notes">
                                        {responses.map(r => {
                                            const billInfo = (request.ClientFeedbackRequestBills || []).find(b => b.bill_id === r.bill_id)?.Bill;
                                            const billLabel = billInfo
                                                ? `${billInfo.bill_type} ${billInfo.bill_number} — ${billInfo.title}`
                                                : `Bill #${r.bill_id}`;
                                            return (
                                                <div key={r.id} className="fdm-bill-note">
                                                    {billInfo ? (
                                                        <Link to={`/legislation/bill/${r.bill_id}`} className="fdm-bill-id" onClick={onClose}>{billLabel}</Link>
                                                    ) : (
                                                        <span className="fdm-bill-id">{billLabel}</span>
                                                    )}
                                                    <p className="fdm-note-text">{r.notes || <em>No notes provided.</em>}</p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="modal-footer fdm-footer">
                        <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
